<template>
  <div style="overflow: auto; margin-top: 20px;">
    <div style="display: inline-flex;" v-if="images">
      <template v-for="(item, i) in images">
        <div
          :key="i"
          class="message mr-2"
          style="
        position: relative;
        border-radius: 12px;
        width: 181px;
        overflow-wrap: break-word;
        min-height: 22px;
        min-width: 14px;
        line-height: 15.36px;
        overflow: hidden;
        "
        >
          <v-btn
            fab
            small
            flat
            style="position: absolute; z-index: 2; right: 0px;"
            @click="deleteImgSlide(item)"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <uploadfile
            ref="answer"
            v-model="images[i]"
            :height="181"
            data-vv-as="Image"
            :data-vv-name="'answer_' + '_image_'"
            v-validate
          ></uploadfile>
        </div>
      </template>
      <div
        @click="addImageSlide"
        v-if="images.length < 3"
        class="message mr-2"
        style="
        cursor: pointer;
        background: rgb(238, 238, 238);
        padding: 70px;
        position: relative;
        border-radius: 12px;
        width: 181px;
        overflow-wrap: break-word;
        min-height: 181px;
        min-width: 14px;
        line-height: 15.36px;
        overflow: hidden;
        text-align: center;
        "
      >
        <i style="font-size: 40px;" class="fas fa-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
export default {
  props: ['value'],
  data() {
    return {
      images: this.value
    }
  },
  components: {
    uploadfile
  },
  methods: {
    addImageSlide() {
      this.images.push(null)
    },
    deleteImgSlide(img) {
      this.images = this.images.filter(item => item !== img)
      this.$emit('input', this.images)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/SlideShow.vue